<template>
  <div>
    <h2>CHS Placements</h2>
    <p>
      Use this database to search for CHS internships and select experiential
      learning opportunities to develop your skills and practical knowledge.
    </p>

    <h3>Internships</h3>
    <ul>
      <li>Multiple opportunities can be selected.</li>
      <li>
        To apply, follow instructions within each internship description and
        select "Start Intent" to begin the application process.
      </li>
      <li>
        <a
          href="https://www.youtube.com/watch?v=fbf5_0L9n2g&feature=youtu.be"
          target="_blank"
          >Watch a video on how to apply.</a
        >
      </li>
      <li>
        <a
          href="https://students.chs.asu.edu/gain-experience/internships"
          target="_blank"
          >View internship guidelines.</a
        >
      </li>
      <li>
        <a
          href="https://students.chs.asu.edu/gain-experience/internships/internship-support"
          target="_blank"
          >Meet with Internship Support Coordinators.</a
        >
      </li>
    </ul>

    <h3>Experiential Learning</h3>

    <ul>
      <li>
        View and apply to Translational Team credit opportunities for CHS 280 /
        484.
      </li>

      <li>Obtain course overrides automatically on application approval.</li>

      <li>
        <a
          href="https://chs.asu.edu/faculty-research/translational-science"
          target="_blank"
          >Learn about CHS Translational Teams.</a
        >
      </li>

      <li>
        <a
          href="https://students.chs.asu.edu/gain-experience/experiential-learning"
          target="_blank"
          >Explore other Experiential Learning options.</a
        >
      </li>

      <li>
        <a href="mailto:CHSel@asu.edu" target="new"
          >Contact Experiential Learning Support</a
        >
      </li>

      <li>
        <a href="mailto:CHSEL@asu.edu" target="new"
          >Schedule An Experiential Learning Appointment</a
        >
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style scoped>
</style>
